interface SectionHeadingProps {
  no: string;
  title: string;
  desc: string;
  actionLabel?: string;
  actionHref?: string;
}

export default function SectionHeading({
  no,
  title,
  desc,
  actionLabel,
  actionHref,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 border-b border-background-200 pb-4 md:flex-row md:items-end md:justify-between md:gap-6">
      <div className="flex items-start gap-4">
        <span className="mt-1 font-heading text-3xl font-black leading-none text-primary-300 md:text-4xl">
          {no}
        </span>
        <div>
          <h3 className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl">
            {title}
          </h3>
          <p className="mt-1.5 max-w-2xl text-xs leading-relaxed text-foreground-600 md:text-sm">
            {desc}
          </p>
        </div>
      </div>
      {actionLabel && actionHref && (
        <a
          href={actionHref}
          className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-semibold text-primary-600 hover:text-primary-700 md:text-sm"
        >
          {actionLabel}
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </a>
      )}
    </div>
  );
}